var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchwellwertCo2Feuchte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "17.6389mm",
    height: "17.9917mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 280 286",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_x0020_-_x0020_CO2_x0020__x002f__x0020_Feuchte"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8AC43F",
    d: "M30 129c-9,-1 -13,-4 -16,-7 1,-8 5,-14 9,-23 2,-6 5,-11 9,-14 4,-4 8,-7 12,-10 7,-5 14,-7 16,-8 2,-1 6,-2 11,-4 4,-2 10,-4 15,-6 10,-5 15,-15 15,-15 0,0 -9,5 -19,8 -5,2 -10,4 -15,5 -5,1 -9,2 -11,3 -4,1 -29,9 -42,33 -3,7 -5,13 -6,19 -3,-1 -7,-4 -7,-10 -2,-9 -1,-37 26,-52 28,-16 59,-13 74,-17 14,-5 20,-23 20,-23 0,0 0,113 -91,121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#28AAE1",
    d: "M265 221c-8,-17 -28,-37 -36,-73 -8,36 -29,55 -35,73 -5,13 -6,26 1,39 7,13 20,20 34,20 14,0 27,-7 34,-20 8,-13 7,-26 2,-39zm-36 51l0 0c-9,0 -16,-3 -22,-10 3,2 6,3 9,4 16,3 32,-8 36,-25 0,-1 0,-2 0,-3 0,-1 0,-1 0,-2 0,-1 0,-1 0,-2 1,-2 1,-4 1,-6 -1,-2 8,-1 7,14 -1,17 -14,30 -31,30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 0,
    y1: 286,
    x2: 280,
    y2: 0
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 11.2014,
    x1: 6,
    y1: 274,
    x2: 263,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M190 109c0,11 -8,20 -19,20 -11,0 -20,-9 -20,-20 0,-11 9,-19 20,-19 11,0 19,8 19,19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M190 109c0,11 -8,20 -19,20 -11,0 -20,-9 -20,-20 0,-11 9,-19 20,-19 11,0 19,8 19,19z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchwellwertCo2Feuchte);
export default __webpack_public_path__ + "static/media/Schwellwert_CO2_Feuchte.abc3b8a1734828a7ac9aa85ce02a7d2c.svg";
export { ForwardRef as ReactComponent };